import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import ButtonAntd from '@deprecated-ui/common/Button';
import Input from '@deprecated-ui/common/Input';
import ModalAntd from '@deprecated-ui/common/Modal';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import styled, { css, keyframes } from 'styled-components';
import NumberFormat from 'react-number-format';

const Modal = styled(ModalAntd).attrs({
  zIndex: 1031, // To Overlap Popover StreamItemOption
  transitionName: '',
  maskTransitionName: '',
})`
  .ant-modal-content {
    border-radius: 3px !important;
  }
  .ant-modal-header {
    padding: 0 20px !important;
    height: 40px;
    border-color: ${color.gainsboro};
    border-radius: 3px !important;
  }
  .ant-modal-body {
    padding: 20px;
  }
  .ant-modal-footer {
    padding: 0 !important;
    text-align: left;
    display: flex;
  }
  .ant-modal-close-x {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
  }
`;

const Select = styled.select`
  padding: 8px;
  line-height: 14px;
  width: 100%;
  border-radius: 3px;
  font-size: 14px;
  margin: 5px 0;
  border: 1px solid ${color.gainsboro};
`;

const Option = styled(Text).attrs({ as: 'option' })``;

const TextArea = styled(Input.TextArea)`
  margin: 5px 0;
`;

const TippingWrapper = styled.div`
  @media ${device.tablet} {
    padding: 0 12px 14px 12px;
  }
`;

const Button = styled(ButtonAntd)`
  margin-left: 0px !important;
  border-radius: 0px;
`;

interface ButtonTippingProps {
  isSelected: boolean;
  [key: string]: any;
}

const ButtonTipping = styled.button<ButtonTippingProps>`
  font-size: 12px;
  font-family: ProximaNovaRg;
  min-width: 70px;
  border-radius: 3px;
  padding: 6px 12px;
  border: 1px solid ${color.whisper};
  background: ${color.light};

  ${({ isSelected }) =>
    isSelected &&
    css`
      background: ${color.mintCream};
      border: 1px solid ${color.primary};
      color: ${color.primary};
    `}

  @media ${device.mobileL} {
    min-width: 100px;
  }
`;

const InputAmountTipping = styled(NumberFormat)`
  border-radius: 3px;
  padding: 10px 18px;
  line-height: 16.1px;
  border: 1px solid ${color.whisper};

  &.bold-input {
    font-family: var(--bold-font);

    ::placeholder {
      font-family: var(--regular-font);
      color: ${color.whisper};
    }
  }

  &.ash-input {
    background-color: #f7f7f7;
  }

  ::placeholder {
    font-family: var(--font-bold);
    color: ${color.whisper};
  }
`;

const TextareaTippingMessage = styled(Input.TextArea)`
  border-radius: 3px;
  max-height: 62px;
  border: 1px solid ${color.whisper};
  padding: 10px 18px;
  resize: none;

  ::placeholder {
    font-family: var(--font-bold);
    color: ${color.whisper};
  }
`;

const ButtonSendTipping = styled(ButtonAntd)`
  border-radius: 3px;
  :disabled {
    background: #cceee1;
    border: none;
  }
`;

const SModalReport = styled(Modal)`
  .ant-modal-header {
    border-radius: 3px 3px 0 0 !important;
    border-bottom: 1px solid ${color.gainsboro};
  }

  .ant-modal-footer {
    button:first-child {
      border-radius: 0 0 0 3px;
    }
    button:last-child {
      border-radius: 0 0 3px 0;
    }
  }
`;

const SModalInsight = styled(Modal)`
  .ant-modal-body {
    padding: 30px !important;
    max-height: 500px;
    overflow: scroll;
  }
`;

const InsightWrapper = styled(Flex).attrs({
  direction: 'column-reverse',
})`
  #insight-detail {
    margin-bottom: 20px;
    width: 100%;
    border-left: unset;
  }
  #post-detail {
    width: 100%;
    border-right: unset;
  }
  @media ${device.tablet} {
    flex-direction: row;
    #insight-detail {
      margin-bottom: unset;
      padding-left: 20px;
      width: 50%;
      border-left: 1px solid #dadada;
    }
    #post-detail {
      width: 50%;
      padding-right: 20px;
      border-right: 1px solid #dadada;
    }
  }
`;

const PostInsightContainer = styled.div`
  position: relative;
`;

const PostInsightFreeze = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: 0 0;
  z-index: 1;
`;

const InsightContainer = styled.div`
  width: 50%;
`;

const AnnouncementCompanyCard = styled(Flex).attrs({
  align: 'center',
})`
  border-radius: 4px;
  border: 1px solid ${color.downgray};
  gap: 16px;
  padding: 11px 15px;
  margin-bottom: 24px;
  cursor: pointer;
`;

const AnnouncementCompanyCardIcon = styled.div`
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: ${color.downgray};
  justify-content: center;

  img {
    border-radius: 50%;
    width: 54px;
    height: 54px;
  }
`;

const AnnouncementAttachmentLabel = styled(Text)`
  padding-bottom: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid #f1f1f1;
`;

const loadingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const AnnouncementLoading = styled.div`
  position: relative;
  border-radius: 50%;
  img {
    animation: ${loadingAnimation} 1s infinite linear;
  }
`;

const AttachmentList = styled.ul`
  list-style-type: none;
  padding-left: 0px;
  margin-bottom: 0px;
  li {
    border-bottom: 1px solid #f1f1f1;
  }
  li:last-child {
    border-bottom: unset !important;
  }

  li > a > div > p {
    word-break: break-all;
    padding-right: 0;
  }
`;

const SymbolErrorIcon = styled.span`
  background: #3a645c;
  color: ${color.light};
  font-size: 20px;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export {
  Modal,
  Select,
  Option,
  TextArea,
  TippingWrapper,
  Button,
  ButtonTipping,
  InputAmountTipping,
  TextareaTippingMessage,
  ButtonSendTipping,
  SModalReport,
  SModalInsight,
  InsightWrapper,
  PostInsightContainer,
  PostInsightFreeze,
  InsightContainer,
  AnnouncementCompanyCard,
  AnnouncementCompanyCardIcon,
  AnnouncementAttachmentLabel,
  AnnouncementLoading,
  AttachmentList,
  SymbolErrorIcon,
};
